import { sizes } from "../utils";
import type { MontaSVGProps } from "../types";
const Show = ({
  size = "medium",
  color = "inherit",
  ...props
}: MontaSVGProps) => {
  const computedSize = sizes[size] || size;
  props.style = {
    ...props.style,
    color
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={computedSize}
      height={computedSize}
      fill={color}
      {...props}
    >
      <g
        fill="none"
        stroke="inherit"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        clipRule="evenodd"
      >
        <path d="M2.75 12.052c0 3.28 4.142 7.302 9.252 7.302 5.109 0 9.252-4.019 9.252-7.302S17.111 4.75 12.002 4.75 2.75 8.772 2.75 12.052" />
        <path d="M15.164 12.052a3.162 3.162 0 1 1-6.325 0 3.162 3.162 0 0 1 6.325 0" />
      </g>
    </svg>
  );
};
export default Show;
